module.exports = __webpack_public_path__ + "static/media/helena-icon.2abddd38.png";